export default [
    {
        path: 'acc/puton',
        name: 'acc.puton',
        meta: {
            title: '寄售角色',
            // header2: true,
            noBottom:true,
            noheader:true,
            pr0:true,
            pl0:true
        },
        component: () => import('./Puton')
    },
    {
        path: 'acc/goods',
        name: 'acc.goods',
        meta: {
            title: '角色详情',
            header2: true,
            noBottom:true,
            pr0:true,
            pl0:true,
            unPullRefresh:true,
            accgoods: true

        },
        component: () => import('./Goods')
    },
    {
        path: 'acc/buy',
        name: 'acc.buy',
        meta: {
            title: '收货信息',
            header2: true,
            noBottom:true,
            pr0:true,
            pl0:true,
        },
        component: () => import('./Buy')
    },
    {
        path: 'order/status',
        name: 'order.status',
        meta: {
            title: '订单详情',
            header2: true,
            noBottom:true,
            white:true
        },
        component: () => import('./OrderStatus')
    }
]